"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _underscore = require("underscore");

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _colors = require("HubStyleTokens/colors");

var _misc = require("HubStyleTokens/misc");

var _FormattedCurrency = _interopRequireDefault(require("I18n/components/FormattedCurrency"));

var _FormattedList = _interopRequireDefault(require("I18n/components/FormattedList"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var CustomRenderer = _interopRequireWildcard(require("UIComponents/utils/propTypes/customRenderer"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UICardHero = _interopRequireDefault(require("UIComponents/card/UICardHero"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIIconRating = _interopRequireDefault(require("UIComponents/input/UIIconRating"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIHoverlay = _interopRequireDefault(require("UIComponents/overlay/UIHoverlay"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var GoodTypes = _interopRequireWildcard(require("../../constants/GoodTypes"));

var _ModuleCompatibilityTagTypes = _interopRequireDefault(require("../../constants/ModuleCompatibilityTagTypes"));

var _PackCounts = _interopRequireDefault(require("./PackCounts"));

var _class, _temp, _class2, _temp2, _class3, _temp3;

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 0;\n  padding-bottom: 75%;\n\n  /* Prevent alt text from displaying while image is loading on Firefox */\n  color: white;\n  background-color: white;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-weight: ", ";\n  max-width: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MAX_TILE_WIDTH = 480;
var MINIMUM_REQUIRED_REVIEWS = 3;
var StyledCardWrapper = (0, _styledComponents.default)(_UICardWrapper.default).withConfig({
  displayName: "GoodTile__StyledCardWrapper",
  componentId: "sc-1ev3xd6-0"
})(_templateObject(), _colors.OBSIDIAN, _misc.WEB_FONT_MEDIUM_WEIGHT, function (props) {
  return props.maxWidth;
});

var StyledAspectRatioContainer = _styledComponents.default.div.withConfig({
  displayName: "GoodTile__StyledAspectRatioContainer",
  componentId: "sc-1ev3xd6-1"
})(_templateObject2());

var TemplateDeviceHeader =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TemplateDeviceHeader, _Component);

  function TemplateDeviceHeader() {
    (0, _classCallCheck2.default)(this, TemplateDeviceHeader);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(TemplateDeviceHeader).apply(this, arguments));
  }

  (0, _createClass2.default)(TemplateDeviceHeader, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIFlex.default, {
        justify: "start",
        align: "center",
        className: "good-tile-template-header"
      }, _react.default.createElement("span", {
        className: "good-tile-template-circle"
      }), _react.default.createElement("span", {
        className: "good-tile-template-circle"
      }), _react.default.createElement("span", {
        className: "good-tile-template-circle"
      }));
    }
  }]);
  return TemplateDeviceHeader;
}(_react.Component);

var BaseTile = (_temp = _class =
/*#__PURE__*/
function (_Component2) {
  (0, _inherits2.default)(BaseTile, _Component2);

  function BaseTile() {
    (0, _classCallCheck2.default)(this, BaseTile);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(BaseTile).apply(this, arguments));
  }

  (0, _createClass2.default)(BaseTile, [{
    key: "renderTileLink",
    value: function renderTileLink(children) {
      var _this$props = this.props,
          goodUrlToken = _this$props.goodUrlToken,
          LinkComponent = _this$props.linkRenderer,
          onClick = _this$props.onClick,
          previewMode = _this$props.previewMode;

      if (previewMode || !goodUrlToken) {
        return children;
      }

      return CustomRenderer.render(LinkComponent, {
        children: children,
        href: this.linkHref,
        onClick: onClick,
        style: {
          textDecoration: 'none'
        }
      });
    }
  }, {
    key: "renderTileContent",
    value: function renderTileContent() {
      var _this$props2 = this.props,
          goodContentComponent = _this$props2.goodContentComponent,
          goodImageUrl = _this$props2.goodImageUrl,
          goodName = _this$props2.goodName,
          hoverlayContent = _this$props2.hoverlayContent;

      var renderedContent = _react.default.createElement(StyledAspectRatioContainer, null, goodContentComponent || _react.default.createElement(_UIImage.default, {
        src: goodImageUrl,
        alt: goodName
      }));

      if (hoverlayContent) {
        return renderedContent;
      }

      return this.renderTileLink(renderedContent);
    }
  }, {
    key: "renderRating",
    value: function renderRating(reviewInfo) {
      if (!reviewInfo || reviewInfo.get('totalCount') < MINIMUM_REQUIRED_REVIEWS) {
        return _react.default.createElement(_Small.default, {
          use: "help"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: "marketplacelib.goodTile.noRatings"
        }));
      }

      return _react.default.createElement(_UIIconRating.default, {
        defaultValue: reviewInfo.get('rating'),
        disabled: true,
        iconSize: "xxs",
        showPercentage: true
      });
    }
  }, {
    key: "renderGoodPriceMessage",
    value: function renderGoodPriceMessage(free, price) {
      if (free) {
        return _react.default.createElement(_FormattedMessage.default, {
          message: "marketplacelib.goodTile.price.free"
        });
      }

      return _react.default.createElement(_FormattedCurrency.default, {
        value: price,
        unit: "$",
        precision: 0
      });
    }
  }, {
    key: "renderHoverlay",
    value: function renderHoverlay(hoverlayContent, renderedCard) {
      var renderedContent = _react.default.createElement(_UIFlex.default, {
        className: "p-all-4",
        direction: "column",
        justify: "between"
      }, _react.default.createElement(_UIBox.default, {
        grow: 1,
        shrink: 1,
        style: {
          overflowY: 'auto'
        }
      }, hoverlayContent), _react.default.createElement(_UIBox.default, {
        grow: 0,
        shrink: 0
      }, _react.default.createElement(_UIButton.default, {
        use: "primary"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "marketplacelib.goodTile.detailsButtonText"
      }))));

      return this.renderTileLink(_react.default.createElement(_UIHoverlay.default, {
        foregroundContent: renderedContent,
        use: "full-card"
      }, renderedCard));
    }
  }, {
    key: "renderCardWrapper",
    value: function renderCardWrapper() {
      var _this$props3 = this.props,
          cardClassName = _this$props3.cardClassName,
          cardProps = _this$props3.cardProps,
          contentClassName = _this$props3.contentClassName,
          goodName = _this$props3.goodName,
          goodPrice = _this$props3.goodPrice,
          goodSubType = _this$props3.goodSubType,
          isFree = _this$props3.isFree,
          maxWidth = _this$props3.maxWidth,
          onPackDetailsPage = _this$props3.onPackDetailsPage,
          reviewInfo = _this$props3.reviewInfo,
          showDevice = _this$props3.showDevice,
          showPrice = _this$props3.showPrice,
          showRating = _this$props3.showRating,
          showSubType = _this$props3.showSubType;
      return _react.default.createElement(StyledCardWrapper, (0, _extends2.default)({}, cardProps, {
        className: cardClassName,
        compact: true,
        maxWidth: maxWidth
      }), showDevice && _react.default.createElement(TemplateDeviceHeader, null), _react.default.createElement(_UICardHero.default, {
        className: contentClassName
      }, this.renderTileContent()), _react.default.createElement(_UICardSection.default, {
        flush: true,
        className: "m-x-4 p-y-2"
      }, _react.default.createElement(_UIFlex.default, {
        justify: "between"
      }, _react.default.createElement(_UIBox.default, null, _react.default.createElement(_UITruncateString.default, null, goodName)), showRating && goodSubType !== GoodTypes.APP && _react.default.createElement(_UIBox.default, {
        shrink: 0
      }, onPackDetailsPage ? null : this.renderRating(reviewInfo))), _react.default.createElement(_UIFlex.default, {
        justify: "between"
      }, showSubType && _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_UITruncateString.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: "marketplacelib.goodSubTypes." + goodSubType
      }))), showPrice && _react.default.createElement(_UIBox.default, {
        shrink: 0
      }, onPackDetailsPage || goodSubType === GoodTypes.APP ? null : this.renderGoodPriceMessage(isFree, goodPrice)))));
    }
  }, {
    key: "render",
    value: function render() {
      var hoverlayContent = this.props.hoverlayContent;
      var renderedCard = this.renderCardWrapper();

      if (hoverlayContent) {
        return this.renderHoverlay(hoverlayContent, renderedCard);
      }

      return renderedCard;
    }
  }, {
    key: "linkHref",
    get: function get() {
      return _Routes.default.marketplace(this.props.goodUrlToken, this.props.redirectUrl);
    }
  }]);
  return BaseTile;
}(_react.Component), _class.propTypes = {
  cardClassName: _react.PropTypes.string,
  cardProps: _react.PropTypes.object,
  contentClassName: _react.PropTypes.string,
  goodName: _react.PropTypes.string.isRequired,
  goodPrice: _react.PropTypes.number,
  goodSubType: _react.PropTypes.string.isRequired,
  goodContentComponent: _react.PropTypes.node,
  goodImageUrl: _react.PropTypes.string,
  goodUrlToken: _react.PropTypes.string,
  hoverlayContent: _react.PropTypes.node,
  isFree: _react.PropTypes.bool,
  linkRenderer: CustomRenderer.propType.isRequired,
  maxWidth: _react.PropTypes.number.isRequired,
  onClick: _react.PropTypes.func,
  onPackDetailsPage: _react.PropTypes.bool,
  previewMode: _react.PropTypes.bool,
  redirectUrl: _react.PropTypes.string,
  reviewInfo: _react.PropTypes.instanceOf(_immutable.default.Map),
  showDevice: _react.PropTypes.bool,
  showPrice: _react.PropTypes.bool,
  showRating: _react.PropTypes.bool,
  showSubType: _react.PropTypes.bool
}, _class.defaultProps = {
  cardProps: {},
  isFree: false,
  linkRenderer: _UILink.default,
  maxWidth: MAX_TILE_WIDTH,
  onPackDetailsPage: false,
  previewMode: false,
  showDevice: false,
  showPrice: true,
  showRating: true,
  showSubType: true
}, _temp);
var ModuleTile = (_temp2 = _class2 =
/*#__PURE__*/
function (_Component3) {
  (0, _inherits2.default)(ModuleTile, _Component3);

  function ModuleTile() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ModuleTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ModuleTile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderSummary = function (summary) {
      return summary && _react.default.createElement(_UISection.default, null, _react.default.createElement("h5", {
        className: "m-bottom-1"
      }, _this.props.goodName), _react.default.createElement("div", null, summary));
    };

    _this.renderCompatibility = function (_compatibility) {
      if (!(_compatibility && _compatibility.length)) {
        return null;
      }

      var compatibility = _compatibility;

      if (_this.isCompatibleWithAnyType) {
        compatibility = Object.keys((0, _underscore.omit)(_ModuleCompatibilityTagTypes.default, _ModuleCompatibilityTagTypes.default.COMPATIBLE_ANY));
      }

      return _react.default.createElement(_UISection.default, null, _react.default.createElement("h5", {
        className: "m-bottom-2"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "marketplacelib.goodTile.moduleTile.compatibility.header"
      })), _react.default.createElement(_FormattedList.default, null, compatibility.map(function (type) {
        return _react.default.createElement(_FormattedMessage.default, {
          key: type,
          message: "marketplacelib.ModuleCompatibilityTagTypes." + type
        });
      })));
    };

    _this.renderHoverlay = function (compatibility, summary) {
      if (!(compatibility || summary)) {
        return null;
      }

      return _react.default.createElement(_UISection.default, null, _this.renderSummary(summary), _this.renderCompatibility(compatibility));
    };

    return _this;
  }

  (0, _createClass2.default)(ModuleTile, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          moduleCompatibility = _this$props4.moduleCompatibility,
          moduleSummary = _this$props4.moduleSummary,
          rest = (0, _objectWithoutProperties2.default)(_this$props4, ["moduleCompatibility", "moduleSummary"]);
      return _react.default.createElement(BaseTile, (0, _extends2.default)({}, rest, {
        hoverlayContent: this.renderHoverlay(moduleCompatibility, moduleSummary)
      }));
    }
  }, {
    key: "isCompatibleWithAnyType",
    get: function get() {
      var moduleCompatibility = this.props.moduleCompatibility;
      return moduleCompatibility && moduleCompatibility.some(function (type) {
        return type === _ModuleCompatibilityTagTypes.default.COMPATIBLE_ANY;
      });
    }
  }]);
  return ModuleTile;
}(_react.Component), _class2.propTypes = {
  goodName: _react.PropTypes.string.isRequired,
  moduleCompatibility: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(Object.keys(_ModuleCompatibilityTagTypes.default))),
  moduleSummary: _react.PropTypes.string
}, _temp2);

var AppTile =
/*#__PURE__*/
function (_Component4) {
  (0, _inherits2.default)(AppTile, _Component4);

  function AppTile() {
    (0, _classCallCheck2.default)(this, AppTile);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(AppTile).apply(this, arguments));
  }

  (0, _createClass2.default)(AppTile, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          moduleSummary = _this$props5.moduleSummary,
          rest = (0, _objectWithoutProperties2.default)(_this$props5, ["moduleSummary"]);
      var summary = moduleSummary.indexOf('span') > -1 ? moduleSummary.replace('<span>', '<h5 class="m-bottom-1">').replace('</span>', '</h5>') : "<h5 class=\"m-bottom-1\">" + rest.goodName + "</h5>" + moduleSummary;
      return _react.default.createElement(BaseTile, (0, _extends2.default)({}, rest, {
        hoverlayContent: _react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: summary
          }
        })
      }));
    }
  }]);
  return AppTile;
}(_react.Component);

var PackTile = (_temp3 = _class3 =
/*#__PURE__*/
function (_Component5) {
  (0, _inherits2.default)(PackTile, _Component5);

  function PackTile() {
    (0, _classCallCheck2.default)(this, PackTile);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(PackTile).apply(this, arguments));
  }

  (0, _createClass2.default)(PackTile, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          packCounts = _this$props6.packCounts,
          rest = (0, _objectWithoutProperties2.default)(_this$props6, ["packCounts"]);
      return _react.default.createElement(BaseTile, (0, _extends2.default)({}, rest, {
        hoverlayContent: _react.default.createElement(_PackCounts.default, {
          abbreviateList: true,
          packCounts: packCounts
        })
      }));
    }
  }]);
  return PackTile;
}(_react.Component), _class3.propTypes = {
  packCounts: _react.PropTypes.instanceOf(_immutable.default.List)
}, _class3.defaultProps = {
  packCounts: _immutable.default.List()
}, _temp3);

var TemplateTile =
/*#__PURE__*/
function (_Component6) {
  (0, _inherits2.default)(TemplateTile, _Component6);

  function TemplateTile() {
    (0, _classCallCheck2.default)(this, TemplateTile);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(TemplateTile).apply(this, arguments));
  }

  (0, _createClass2.default)(TemplateTile, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(BaseTile, this.props);
    }
  }]);
  return TemplateTile;
}(_react.Component);

var ThemeTile =
/*#__PURE__*/
function (_Component7) {
  (0, _inherits2.default)(ThemeTile, _Component7);

  function ThemeTile() {
    (0, _classCallCheck2.default)(this, ThemeTile);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(ThemeTile).apply(this, arguments));
  }

  (0, _createClass2.default)(ThemeTile, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(BaseTile, this.props);
    }
  }]);
  return ThemeTile;
}(_react.Component);

var GoodTile =
/*#__PURE__*/
function (_Component8) {
  (0, _inherits2.default)(GoodTile, _Component8);

  function GoodTile() {
    (0, _classCallCheck2.default)(this, GoodTile);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(GoodTile).apply(this, arguments));
  }

  (0, _createClass2.default)(GoodTile, [{
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          goodType = _this$props7.goodType,
          rest = (0, _objectWithoutProperties2.default)(_this$props7, ["goodType"]);

      switch (goodType) {
        case GoodTypes.CUSTOM_MODULE:
          return _react.default.createElement(ModuleTile, rest);

        case GoodTypes.PACK:
          return _react.default.createElement(PackTile, rest);

        case GoodTypes.CMS_THEME:
          return _react.default.createElement(ThemeTile, rest);

        case GoodTypes.COS_TEMPLATE:
          return _react.default.createElement(TemplateTile, rest);

        case GoodTypes.APP:
          return _react.default.createElement(AppTile, rest);

        default:
          return null;
      }
    }
  }]);
  return GoodTile;
}(_react.Component);

exports.default = GoodTile;
GoodTile.propTypes = {
  goodType: _react.PropTypes.oneOf(Object.keys(GoodTypes)).isRequired
};
module.exports = exports.default;